// Query-key factory for the Admin User Impersonation surfaces.
//
// Required by the stale-after-save gate (`src/test/staleAfterSaveGate.test.ts`):
// every `queryKey: [...]` array literal — including the ones handed to
// `invalidateQueries` — must live in a `*Keys` factory file. The impersonation
// module holds no reads of its own (session state arrives on `/auth/me`, owned
// by AuthProvider), but PROVISIONING a QA account writes into two rosters that
// other pages read, so those prefixes are registered here.

/**
 * Root prefix reserved for any future impersonation read. Nothing registers
 * under it today — the acting session's impersonation state rides `MeDto`.
 */
export const impersonationKeys = {
  all: () => ["impersonation"] as const,
};

/**
 * Prefixes a freshly-ensured QA account must appear under.
 *
 * `staffRoster` matches the `["users", …]` family (`UsersPage`'s list, the
 * shared assignable-users lookup, the @mention search); `portalAccounts`
 * mirrors `portalAccountsKeys.all()` so a new portal QA account shows up in
 * the Portal Accounts registry without a manual reload.
 */
export const qaUserKeys = {
  staffRoster: () => ["users"] as const,
  portalAccounts: () => ["portal-accounts"] as const,
};
